import { Auth } from 'aws-amplify'
import {
    isAdmin,
    isMultipleOrganization,
} from '../../../../Utils/ServerUtil'
import config from '../../../../config/runtime'
import { usePackages } from '../../../../services/api'

interface FetchDataParams {
    selectedEmployees: string[]
    filter: string[]
    pageNumber: number
    rowsPerPage: number
}

const LAST_URL_KEY = 'last_fetch_url'

// Hook for using packages data with TanStack Query
export const usePackagesData = ({
                                    selectedEmployees,
                                    filter,
                                    pageNumber,
                                    rowsPerPage,
                                }: FetchDataParams) => {
    // Optimize parameter restoration - only restore if current params are empty
    let finalEmployees = selectedEmployees || []
    let finalFilter = filter || []
    let finalPageNumber = pageNumber
    let finalRowsPerPage = rowsPerPage
    let restoredFromCache = false

    // Only attempt cache restoration if no parameters are provided
    if (!finalEmployees.length && !finalFilter.length && finalPageNumber === 0) {
        const cachedUrl = localStorage.getItem(LAST_URL_KEY)
        if (cachedUrl) {
            try {
                const url = new URL(cachedUrl)
                const params = new URLSearchParams(url.search)

                // const cachedEmployees = params.get('by_user')?.split(',').filter(Boolean) || []
                const cachedFilter = params.get('status')?.split(',').filter(Boolean) || []
                const cachedPage = Math.max(0, parseInt(params.get('page') || '1') - 1)
                const cachedSize = Math.max(1, parseInt(params.get('size') || '10'))

                if (cachedFilter.length) {
                    // finalEmployees = cachedEmployees
                    finalFilter = cachedFilter
                    finalPageNumber = cachedPage
                    finalRowsPerPage = cachedSize
                    restoredFromCache = true
                }
            } catch (error) {
                console.error('Error parsing cached URL:', error)
            }
        }
    }

    // Save current parameters to cache for future use
    const employeesParam = finalEmployees.join(',')
    const statusParam = finalFilter.join(',')

    if (employeesParam || statusParam) {
        const cacheUrl = `${process.env.API_ENDPOINT_V3}/packages?page=${
            finalPageNumber + 1
        }&size=${finalRowsPerPage}&by_user=${employeesParam}&status=${statusParam}`
        localStorage.setItem(LAST_URL_KEY, cacheUrl)
    }

    // Debug logging
    if (process.env.NODE_ENV === 'development') {
        console.log('usePackagesData:', {
            restoredFromCache,
            employees: employeesParam,
            status: statusParam,
            page: finalPageNumber,
            size: finalRowsPerPage
        })
    }

    // Determine if query should be enabled
    const shouldFetch = finalEmployees.length > 0 || finalFilter.length > 0 || restoredFromCache

    // Use the TanStack Query hook with enabled option
    return usePackages({
        selectedEmployees: finalEmployees,
        filter: finalFilter,
        pageNumber: finalPageNumber,
        rowsPerPage: finalRowsPerPage
    }, {
        enabled: shouldFetch,
        
    })
}
